import { DataTableRow, DataTableRowList, DataTableRowCell } from 'Elements';
import styles from 'partials/dot-loading.module.scss';
import tableStyles from 'partials/data-table/data-table.module.scss';

export const DataTableLoading = () => {
	return (
		<DataTableRow>
			<DataTableRowList>
				<DataTableRowCell cellClassName="w-100">
					<div className={tableStyles.loading}>
						<div className={styles.loading}></div>
					</div>
				</DataTableRowCell>
			</DataTableRowList>
		</DataTableRow>
	);
};
